<div id="botonera" class="flex center-center">
  <button
    *ngFor="let vendor of vendors"
    class="btn btn-success btn-lg"
    (click)="crearCaja(vendor)"
  >
    {{ vendor.nombre }}
  </button>
</div>
